//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from "vue-multiselect";

export default {
  name: "VMultiselect",
  components: { Multiselect },
  data() {
    return {
      value: this.currentValue || null,
    };
  },
  props: {
    currentValue: {
      required: false,
    },
    closeOnSelect: {
      default: true,
    },
    disabled: {
      default: false,
    },
    onSelect: {
      required: false,
    },
    options: {
      type: Array,
      default: [],
    },
    placeholder: {
      default: "Select an option",
    },
    searchable: {
      default: false,
    },
    canDeselect: {
      default: false,
    },
    trackBy: {
      required: false,
    },
    label: {
      required: false,
    },
    allowEmpty: {
      default: false,
    },
    noResultHTML: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleSelect(value) {
      this.onSelect && this.onSelect(value);
    },
  },
};
